<template>
  <div class="announcement-outer">
    <BlockTitle title="资产信息" />
    <div class="table-outer">
      <div class="table-head">
        <div class="cell">资产名称</div>
        <div class="cell">资产大类</div>
        <div class="cell">办证额</div>
      </div>
      <div class="table-body">
        <SeamlessScroll
          :list="assetList"
        >
          <template v-slot:scrollInner="{item,index}">
            <div :class="`row ${isEven(index + 1) ? 'zebra':''}`">
              <div class="cell" :title="item.assetName">{{ item.assetName }}</div>
              <div class="cell" :title="item.assetForm">{{ item.assetForm }}</div>
              <div class="cell" :title="item.contractedAmount">{{ item.contractedAmount }}</div>
            </div>
          </template>
        </SeamlessScroll>
      </div>
    </div>
  </div>
</template>

<script>
import BlockTitle from '@/views/public_0983cc/tradeData/components/public/BlockTitle.vue'
import SeamlessScroll from '@/components/base/SeamlessScroll.vue'
import { mapGetters } from 'vuex'

import {
  data_v2_notice
} from '@/api/portal'

export default {
  components: {
    BlockTitle,
    SeamlessScroll
  },
  data() {
    return {
      announcementList: []
    }
  },
  computed: {
    ...mapGetters(['selectLocId']),
    isEven() {
      return function(index) {
        return index % 2 === 0
      }
    }
  },
  watch: {
    selectLocId() {
      this.getAnnouncement()
    }
  },
  created() {
    this.getAnnouncement()
  },
  mounted() {
  },
  methods: {
    // 获取公共
    async getAnnouncement() {
      // const { data } = await data_v2_notice({ locId: this.selectLocId, rows: 20 })
      this.assetList = [
        {
          'assetName': '湖阳坑岭',
          'assetForm': '土地资产',
          'contractedAmount': '10.00亩'
        },
        {
          'assetName': '大厅',
          'assetForm': '固定资产',
          'contractedAmount': '400.00平方米'
        },
        {
          'assetName': '乐昌扶穷电站',
          'assetForm': '其他',
          'contractedAmount': '1.00个'
        },
        {
          'assetName': '全社承包耕地',
          'assetForm': '土地资产',
          'contractedAmount': '125.24亩'
        },
        {
          'assetName': '观音栋山',
          'assetForm': '土地资产',
          'contractedAmount': '712.00亩'
        },
        {
          'assetName': '粤港澳大湾区农产品配送中心',
          'assetForm': '其他',
          'contractedAmount': '370288.21元'
        },
        {
          'assetName': '厕所',
          'assetForm': '固定资产',
          'contractedAmount': '40.00平方米'
        },
        {
          'assetName': '大坪岭锅头督林地',
          'assetForm': '土地资产',
          'contractedAmount': '271.89亩'
        },
        {
          'assetName': '杉木',
          'assetForm': '其他',
          'contractedAmount': '3500.00株'
        },
        {
          'assetName': '村委会修缮',
          'assetForm': '固定资产',
          'contractedAmount': '19999.00平方米'
        },
        {
          'assetName': '路灯',
          'assetForm': '固定资产',
          'contractedAmount': '18000.00座'
        },
        {
          'assetName': '坳背',
          'assetForm': '其他',
          'contractedAmount': '750.00亩'
        },
        {
          'assetName': '篮球场',
          'assetForm': '固定资产',
          'contractedAmount': '1000.00平方米'
        },
        {
          'assetName': '青山窝',
          'assetForm': '土地资产',
          'contractedAmount': '279.40亩'
        },
        {
          'assetName': '园岭墩',
          'assetForm': '土地资产',
          'contractedAmount': '115.00亩'
        },
        {
          'assetName': '上黄耕地',
          'assetForm': '土地资产',
          'contractedAmount': '164.72亩'
        },
        {
          'assetName': '韶关市龙仙农业发展有限公司',
          'assetForm': '其他',
          'contractedAmount': '20000.00分红(元)'
        },
        {
          'assetName': '枫树坝火烧疗青冲',
          'assetForm': '土地资产',
          'contractedAmount': '300.00亩'
        },
        {
          'assetName': '当面山',
          'assetForm': '土地资产',
          'contractedAmount': '3000.00亩'
        },
        {
          'assetName': '背夫山',
          'assetForm': '土地资产',
          'contractedAmount': '167.80亩'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .block-title-outer .title{
    height: auto;
  }
}
.announcement-outer{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.table-outer{
  height: 100%;
  color: #fff;
  .cell{
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }
  .table-head{
    display: flex;
    justify-content: space-between;
    color: rgba($color: #fff, $alpha: .9);
    font-size: 16px;
    padding-bottom: 7px;
    margin: 10px 0 7px 0;
    border-bottom: 2px solid #00468A;
    .cell{
      flex: 1;
      text-align: center;
    }
  }
  .table-body{
    overflow: hidden;
    height: 410px;
    .row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cell{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
        text-align: center;
        &:first-child{
          text-align: left;
        }
      }
      &.zebra{
        background-color: #00468A;
      }

    }
  }
}
</style>
